import React from 'react';
import AllServicesTable from './components/AllServicesTable';

function ServicesPage() {
  return <AllServicesTable />;
}

export default ServicesPage;
